import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStop = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1675_286)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8 0.5C6.41775 0.5 4.87104 0.969192 3.55544 1.84824C2.23985 2.72729 1.21447 3.97672 0.608967 5.43853C0.00346629 6.90034 -0.15496 8.50887 0.153721 10.0607C0.462403 11.6126 1.22433 13.038 2.34315 14.1569C3.46197 15.2757 4.88743 16.0376 6.43928 16.3463C7.99113 16.655 9.59966 16.4965 11.0615 15.891C12.5233 15.2855 13.7727 14.2602 14.6518 12.9446C15.5308 11.629 16 10.0823 16 8.5C15.9977 6.37897 15.1541 4.34547 13.6543 2.84568C12.1545 1.34589 10.121 0.502294 8 0.5ZM8 1.83333C9.53765 1.83211 11.028 2.36517 12.216 3.34133L2.84134 12.716C2.04171 11.7399 1.53578 10.5567 1.38241 9.30429C1.22905 8.05182 1.43458 6.78156 1.97506 5.64136C2.51555 4.50116 3.36876 3.53792 4.43539 2.86376C5.50202 2.18961 6.73819 1.83227 8 1.83333ZM8 15.1667C6.46236 15.1679 4.97205 14.6348 3.784 13.6587L13.1587 4.284C13.9583 5.26011 14.4642 6.44325 14.6176 7.69572C14.771 8.94818 14.5654 10.2184 14.0249 11.3586C13.4845 12.4988 12.6312 13.4621 11.5646 14.1362C10.498 14.8104 9.26182 15.1677 8 15.1667Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1675_286",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgStop;
